<template>
  <BaseButton primary @click="openNewSmsCampaignDialog"> New SMS Campaign </BaseButton>
</template>

<script>
import { projectSmsCampaignsClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      default: null,
    },
    projectId: {
      type: String,
      default: null,
    },
  },
  methods: {
    submit(data) {
      return projectSmsCampaignsClient.store(this.projectId, data);
    },
    openNewSmsCampaignDialog() {
      this.$modal.show({
        component: () =>
          import('@/components/SmsCampaign/CreateSmsCampaignDialog/CreateSmsCampaignDialog.vue'),
        props: {
          accountId: this.accountId,
          defaultData: {
            filter: {
              //
            },
          },
          action: this.submit,
        },
        on: {},
        hideEvent: 'close',
      });
    },
  },
};
</script>
